import Utility from '@/utils/Utility'

export default {
  name: 'TypeText',
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  mounted () {

  },
  computed: {
    body() {
      return this.model.body
    },

    showLinkUrl() {
      return this.model.linkUrl
    },
    linkUrl() {
      return this.model.linkUrl
    },
    soundFile() {
      return this.model.soundFile
    }
  },
}
